import * as React from "react";

interface SVGRProps {
	title?: string;
	titleId?: string;
}

function SvgRecent({
	title,
	titleId,
	...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
	return (
		<svg
			width={24}
			height={24}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			aria-labelledby={titleId}
			{...props}
		>
			{title ? <title id={titleId}>{title}</title> : null}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 12C2 6.479 6.479 2 12 2s10 4.479 10 10-4.479 10-10 10S2 17.521 2 12zm10-8c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 5a1 1 0 011 1v5.75h3.5a1 1 0 110 2H12a1 1 0 01-1-1V6a1 1 0 011-1z"
			/>
		</svg>
	);
}

const MemoSvgRecent = React.memo(SvgRecent);
export default MemoSvgRecent;
